import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-scroll';

import { ScrollLinkContainer, Sidebar, SidebarHeadline } from '@components/PDP/pdp.styles';
import { GIFT_BALANCE_LINK, GIFT_TERMS_LINK, SCROLL_DURATION } from '@components/PDP/pdp.constants';
import { GiftCertificateActions } from '@components/PDP/giftCertificateActions';
import { Variant } from '@definitions/giftCertificate.types';

import { Description, Title, SidebarLinks } from './giftCertificateSidebar.styles';

export interface GiftCertificateSidebarProps {
  onThemeChange: (theme?: Variant) => void;
  theme?: Variant;
  variants: Variant[];
}

export const GiftCertificateSidebar = ({ onThemeChange, theme, variants }: GiftCertificateSidebarProps) => {
  return (
    <Sidebar>
      <SidebarHeadline>
        <Title>
          <FormattedMessage id="giftCertificateSidebar.title" defaultMessage="Gift Card:" />
        </Title>
        <Description>
          <FormattedMessage
            id="giftCertificateSidebar.description"
            defaultMessage="Give the gift of art with a Platform gift card. Select a value, personalize it with your message, and have it emailed to a friend or loved one immediately. It's the perfect present for any special occasion!"
          />
        </Description>
        <GiftCertificateActions onThemeChange={onThemeChange} theme={theme} variants={variants} />
      </SidebarHeadline>
      <SidebarLinks>
        <ScrollLinkContainer>
          <Link to={GIFT_BALANCE_LINK} href={`#${GIFT_BALANCE_LINK}`} spy smooth duration={SCROLL_DURATION}>
            <FormattedMessage id="giftCertificateSidebar.balance" defaultMessage="Check Balance" />
          </Link>
        </ScrollLinkContainer>
        <ScrollLinkContainer>
          <Link to={GIFT_TERMS_LINK} href={`#${GIFT_TERMS_LINK}`} spy smooth duration={SCROLL_DURATION}>
            <FormattedMessage id="giftCertificateSidebar.terms" defaultMessage="Terms & conditions" />
          </Link>
        </ScrollLinkContainer>
      </SidebarLinks>
    </Sidebar>
  );
};
